import $ from 'jquery';
import { updateTextOnly } from '@/js/modules/update_text_only';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function getTrackedTimeCategoryIds() {
    const params = queryString();
    let ids = (params['ids'] || '').split(',');
    if (ids[0] === '' && ids.length === 1) {
      ids = [];
    }
    return new Set(ids);
  }

  function setTrackedTimeCategoryIds(ids) {
    const params = queryString();

    let url = null;
    params['ids'] = Array.from(ids).join(',');

    if (Object.keys(params).length > 0 && $.param(params).length > 0) {
      url = '?' + $.param(params);
    } else {
      url = window.location.pathname;
    }

    window.history.replaceState(null, '', url);
  }

  function updateTrackedTimeCategoriesControls() {
    const selectedCheckboxesLength = $('.checkbox--tracked-time-categories:checked').length;
    const trackedTimeCategoriesCount = $('.data-table__tr').length;
    const totalSelectedTrackedTimeCategories = getTrackedTimeCategoryIds().size;

    if (totalSelectedTrackedTimeCategories > 0) {
      updateTextOnly(
        $('.h-d-button--delete-tracked-time-categories'),
        `Delete (${totalSelectedTrackedTimeCategories})`
      ).removeClass('hide');
      $('.tracked-time-categories-search-form').hide();
    } else {
      $('.h-d-button--delete-tracked-time-categories').addClass('hide');
      $('.tracked-time-categories-search-form').show();
    }

    // check/uncheck the "check all" checkbox based on count
    $('.checkbox--tracked-time-categories-check-all').prop(
      'checked',
      selectedCheckboxesLength === trackedTimeCategoriesCount
    );
  }

  $(document).ready(() => {
    getTrackedTimeCategoryIds().forEach((trackedTimeCategoryId) => {
      $(`.data-table__tr[data-id=${trackedTimeCategoryId}]`)
        .find('.checkbox--tracked-time-categories')
        .prop('checked', true);
    });
    updateTrackedTimeCategoriesControls();

    $(document).on($.modal.CLOSE, '.modal--tracked-time-category-form', (e) => {
      $(e.target).remove();
    });
  });

  $(document).on('change', '.checkbox--tracked-time-categories', (e) => {
    const ids = getTrackedTimeCategoryIds();
    const id = String($(e.target).closest('.data-table__tr').data('id'));

    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    if ($(e.target).is(':checked')) {
      ids.add(id);
    } else {
      ids.delete(id);
    }
    const newIds = Array.from(ids).join(',');

    $('.pagination a').each(function (index, link) {
      const url = new URL(link.href);
      const params = parseQuery(url.search);
      params['ids'] = newIds;
      url.search = '?' + $.param(params);
      link.href = url.href;
    });

    setTrackedTimeCategoryIds(ids);
    updateTrackedTimeCategoriesControls();
  });

  $(document).on('change', '.checkbox--tracked-time-categories-check-all', (e) => {
    $('.checkbox--tracked-time-categories').prop('checked', $(e.target).prop('checked')).change();

    updateTrackedTimeCategoriesControls();
  });

  $(document).on('click', '.h-d-button--delete-tracked-time-categories', (e) => {
    const selectedTrackedTimeCategoryIds = Array.from(getTrackedTimeCategoryIds());

    let bulkDeleteUrl = $(
      '.modal--delete-tracked-time-categories-confirmation .d-button--confirm-delete'
    ).attr('href');

    if (/\?tracked_time_category_ids=.+$/.test(bulkDeleteUrl)) {
      bulkDeleteUrl = bulkDeleteUrl.replace(/\?tracked_time_category_ids=.+$/, '');
    }

    bulkDeleteUrl = bulkDeleteUrl + `?tracked_time_category_ids=${selectedTrackedTimeCategoryIds}`;

    $('.modal--delete-tracked-time-categories-confirmation .d-button--confirm-delete').attr(
      'href',
      bulkDeleteUrl
    );

    $('.modal--delete-tracked-time-categories-confirmation .modal__header').text(
      `Are you sure you want to delete ${selectedTrackedTimeCategoryIds.length} selected services?`
    );

    $('.modal--delete-tracked-time-categories-confirmation').modal();
  });

  $(document).on('click', '.tracked-time-categories-search-form__clear', (e) => {
    const $el = $(e.target);
    $el.siblings('.tracked-time-categories-search-form__field').val('');
    $el.parents('.tracked-time-categories-search-form').submit();
  });

  $(document).on('click', '.p-button--tracked-time-category-form', (e) => {
    const $form = $(e.target).closest('form');
    const name = $form.find('.field--tracked-time-category-name').val();
    const hourlyRate = $form.find('.field--tracked-time-category-hourly-rate').val();
    const nonBillable = $form.find('.green-checkbox--non-billable').is(':checked');
    $form.find('.error-message').hide();

    if (name.trim().length === 0) {
      $form.find('.error-message--tracked-time-category-name').html('Please enter the name').show();
      return false;
    } else if ((hourlyRate.length === 0 || parseFloat(hourlyRate) <= 0) && nonBillable === false) {
      $form
        .find('.error-message--tracked-time-category-hourly-rate')
        .html('Please enter the hourly rate')
        .show();
      return false;
    } else if (!isValidCategoryHourlyRate(hourlyRate) && nonBillable === false) {
      $form
        .find('.error-message--tracked-time-category-hourly-rate')
        .html('Please enter a valid hourly rate')
        .show();
      return false;
    } else {
      $form.submit();
    }
  });

  const isValidCategoryHourlyRate = (hourlyRate) => {
    return /^\d{1,6}(\.\d{1,2})?$/.test(hourlyRate);
  };

  // Refactor
  $(document).on('change', 'input.field--tracked-time-category-image', (e) => {
    const $el = $(e.target);
    const $wrapper = $el.parents('.tracked-time-category-form__image-field-with-preview');
    const $preview = $wrapper.find('img.tracked-time-category-form__image-preview');
    const $removeImageFlagInput = $wrapper.find('input[name="remove_image"]');

    // Update preview
    $preview[0].src = URL.createObjectURL(e.target.files[0]);
    $preview.show();

    // Update preview (hide placeholder)
    $wrapper.find('.tracked-time-category-form__image-placeholder').addClass('hide');

    // Allow image removal
    $wrapper
      .find(
        '.tracked-time-category-form__image-remove-separator, .delete-tracked-time-category-image, .delete-tracked-time-category-image i'
      )
      .show();

    // Unmark image for removal (only for updates)
    if ($removeImageFlagInput.length > 0) {
      $removeImageFlagInput.val('false');
    }
  });

  $(document).on('click', '.delete-tracked-time-category-image', (e) => {
    const el = e.target;
    const wrapper = el.closest('.tracked-time-category-form__image-field-with-preview');
    const removeImageFlagInput = wrapper.querySelector('input[name="remove_image"]');
    const imageFileInput = wrapper.querySelector('input.field--tracked-time-category-image');

    // Update preview (show empty placeholder)
    wrapper
      .querySelectorAll(
        '.field--tracked-time-category-image, .tracked-time-category-form__image-placeholder'
      )
      .forEach((node) => node.classList.remove('hide'));

    // Hide removal button + related elements
    wrapper
      .querySelectorAll(
        '.tracked-time-category-form__image-preview, ' +
          '.tracked-time-category-form__existing-image-name, ' +
          '.tracked-time-category-form__image-remove-separator'
      )
      .forEach((node) => {
        node.style.display = 'none';
      });

    // Unassign previously selected file
    if (imageFileInput) {
      imageFileInput.value = '';
    }

    // Mark image for removal (only for updates)
    if (removeImageFlagInput) {
      removeImageFlagInput.value = 'true';
    }

    // Hide clicked element
    el.style.display = 'none';
  });

  $(document).on('change', '.green-checkbox--non-billable', (e) => {
    const isChecked = $(e.currentTarget).prop('checked');
    $('.tracked-time-category-form__hourly-rate-container').toggleClass('hide', isChecked);
    $('.tracked-time-category-form__taxable-container').toggleClass('hide', isChecked);

    if (isChecked) {
      $('.field--tracked-time-category-hourly-rate').val('0');
      $('.error-message--tracked-time-category-hourly-rate').css('display', 'none');
    }
  });
});
